import { render } from "./ClassDetail.vue?vue&type=template&id=74dfe2dc&scoped=true"
import script from "./ClassDetail.vue?vue&type=script&lang=js"
export * from "./ClassDetail.vue?vue&type=script&lang=js"

import "./ClassDetail.vue?vue&type=style&index=0&id=74dfe2dc&scoped=true&lang=css"

import exportComponent from "F:\\ypx\\zhiniao\\zhiniao-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dfe2dc"]])

export default __exports__